import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Api from "../Api/Api.json";
import BottomTab from './BottomTab';

const ManageStethoReport = () => {
  const [stethoList, setStethoList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.TELEDOC_PROVIDER_API;
    const requestData = {
      task: 'getUnreportedPhonocardiogramScreen'
    };

    axios.post(url, requestData, headers)
      .then(response => {
        //console.log(response.data);
        if (response.data && response.data.length > 0) {
          setStethoList(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setMessage('');
  };

  const handleSubmitReviewRequest = async () => {
    if (!selectedItem) {
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.PATIENT_API;
    const requestData = {
      task: 'submitStethoHeartReportRequest',
      patient_id: selectedItem.pid,
      fileName: selectedItem.fileName
    };

    try {
      const response = await axios.post(url, requestData, headers);

      if (response.status === 200) {
        setMessage('Successfully submitted request');
        // Remove the item from the list locally
        setStethoList(prevList => 
          prevList.filter(item => 
            !(item.pid === selectedItem.pid && item.fileName === selectedItem.fileName)
          )
        );
        // Clear selection after successful submission
        setSelectedItem(null);
      } else {
        setMessage('Request not submitted. Something went wrong.');
      }
    } catch (error) {
      console.error('Error submitting request:', error);
      setMessage('Request not submitted. Something went wrong.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h4>Manage Stetho Report</h4>
      
      {selectedItem && (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <button 
            onClick={handleSubmitReviewRequest}
            disabled={isSubmitting}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: isSubmitting ? 'not-allowed' : 'pointer'
            }}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Review Request'}
          </button>
        </div>
      )}

      {message && (
        <div style={{
          marginTop: '10px',
          marginBottom: '10px',
          padding: '10px',
          backgroundColor: message.includes('Successfully') ? '#d4edda' : '#f8d7da',
          color: message.includes('Successfully') ? '#155724' : '#721c24',
          borderRadius: '4px'
        }}>
          {message}
        </div>
      )}
      
      <table>
        <thead>
          <tr>
            <th>Patient ID</th>
            <th>File Name</th>
          </tr>
        </thead>
        <tbody>
          {stethoList.map((item, index) => {
            const isSelected = selectedItem && 
              selectedItem.pid === item.pid && 
              selectedItem.fileName === item.fileName;
            return (
              <tr 
                key={`${item.pid}-${item.fileName}-${index}`}
                onClick={() => handleRowClick(item)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: isSelected ? '#e3f2fd' : 'transparent'
                }}
              >
                <td>{item.pid}</td>
                <td>{item.fileName}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      
      <BottomTab />
    </div>
  );
};

export default ManageStethoReport;

